"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DynamicConfig {
    constructor(configName, configValue = {}, ruleID = '', secondaryExposures = [], allocatedExperimentName = '') {
        this.name = configName;
        this.value = JSON.parse(JSON.stringify(configValue));
        this.ruleID = ruleID;
        this.secondaryExposures = secondaryExposures;
        this.allocatedExperimentName = allocatedExperimentName;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) {
            return defaultValue;
        }
        if (typeGuard) {
            return typeGuard(val) ? val : defaultValue;
        }
        if (defaultValue == null) {
            return val;
        }
        if (typeof val === typeof defaultValue &&
            Array.isArray(defaultValue) === Array.isArray(val)) {
            return val;
        }
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) {
            return this.value;
        }
        if (defaultValue == null) {
            defaultValue = null;
        }
        if (this.value[key] == null) {
            return defaultValue;
        }
        return this.value[key];
    }
    getRuleID() {
        return this.ruleID;
    }
    getName() {
        return this.name;
    }
    _getSecondaryExposures() {
        return this.secondaryExposures;
    }
    _getAllocatedExperimentName() {
        return this.allocatedExperimentName;
    }
}
exports.default = DynamicConfig;
